import React, { useCallback, useState, useEffect } from "react";
import DataTable from "../../ComponentsFC/DataTable";
// import UI from "../../shared/Components/UI/js";
// import moment from "moment";
import styled from "styled-components";
import { Row, Input, Select, Typography } from "antd";
import DropdownIcon from "../../icons/Dropdown";
import SearchIcon from "../../icons/Search";
import ServiceUsersGroupSubscriptionApi from "../../api_services/subscriptions";
import { Failed, Success } from "../_components/Modal";
import ServiceSubscriptionsApi from "../../api_services/subscriptions";

const EcommerceUserGroupSubscriptionRequestListTable = ({ _this }) => {
  const [tableData, setTableData] = useState([]);
  const [searchResults, setSearchResults] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [totalRecords, setTotalRecords] = useState(0);
  const [tableEntries, setTableEntries] = useState(30);
  const [currentPageNum, setCurrentPageNum] = useState(1);
  // eslint-disable-next-line no-unused-vars
  const [filterByStatus, setFilterByStatus] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [sortByName, setsortByName] = useState("");

  const getAllUserGroupSubscriptionsRequest = useCallback(async () => {
    setIsLoading(true);

    let params = {};

    if (sortByName !== "") {
      params.name = sortByName;
    }

    if (searchQuery) {
      params.keyword = searchQuery;
    }

    if (currentPageNum) {
      params.page = currentPageNum;
      params.limit = tableEntries;
    }

    ServiceSubscriptionsApi.getAllUserGroupSubscriptionsRequest(params).then(
      (res) => {
        setIsLoading(false);
        if (res.status === 200) {
          let data = res.data;
          setTotalRecords(data.length);
          setTableData(data);
        }
      }
    );
  }, [currentPageNum, tableEntries, sortByName, searchQuery]);

  useEffect(() => {
    getAllUserGroupSubscriptionsRequest();
  }, [getAllUserGroupSubscriptionsRequest]);

  const handlePaginateTable = (pageNum) => {
    // console.log("Currently Selected Page # of Antd Table: ", pageNum);
    setCurrentPageNum(pageNum);
  };

  const tableColumnHeader = [
    {
      title: "Group Name",
      dataIndex: "groupName",
      key: "groupName",
      render: (groupName, item) =>
        item?.subscriberUserGroup ? item?.subscriberUserGroup[0]?.name : "--",
      width: 200,
    },
    {
      title: "Subscription Type",
      dataIndex: "planName",
      key: "planName",
      render: (planName) => planName ?? "--",
      width: 200,
    },
    // {
    //   title: "Date Requested",
    //   dataIndex: "dateRequested",
    //   key: "dateRequested",
    //   render: (dateRequested, item) =>item?.subscriberUserGroup ? UI.momentPHTimezone(item?.subscriberUserGroup[0]?.dateRequested).format('MM/DD/YYYY') : "--",
    //   width: 200,
    // },
    // {
    //   title: "End Date",
    //   dataIndex: "user",
    //   key: "emailAddress",
    //   render: (user) => {
    //     return "10/11/2022"
    //   },
    //   width: 300,
    // },
    // {
    //   title: "Status",
    //   dataIndex: "gender",
    //   key: "gender",
    //   render: (user) => {
    //     return UI.get_color_status_text("Requested")
    //   },
    //   width: 200,
    // },
    {
      title: "Action",
      dataIndex: "createdAt",
      key: "date_added",
      render: (item, data) => {
        // console.log(data.subscriberUserGroup[0].userGroupId)
        return (
          <ActionStyledSelect
            getPopupContainer={(trigger) => trigger.parentNode} // Avoid Select dropdown moves when scrolling
            placeholder="Set Status"
            style={{
              width: "100%",
              height: "20px !important",
            }}
            // value={"Approve"}
            // allowClear
            suffixIcon={<DropdownIcon />}
            onChange={(value) =>
              updateRequestStatus(
                value,
                data._id,
                data.subscriberUserGroup[0]?.userGroupId
              )
            }
            onClear={() => handleClearViaSelectField("Status")}
          >
            <Select.Option title="Action" value="ACTIVATED">
              Approve
            </Select.Option>
            <Select.Option title="Action" value="DISAPPROVED">
              Disapprove
            </Select.Option>
            {/* <Select.Option title="Action" value="CANCELLED">
              Cancel
            </Select.Option> */}
            {/* <Select.Option title="Action" value="CANCELLED">
              Merchant Cancel
            </Select.Option> */}
          </ActionStyledSelect>
        );
      },
      width: 50,
    },
  ];

  const handleChangeNumOfEntries = (value) => {
    setTableEntries(Number(value));
  };

  const handleChangeSearchQuery = (e) => {
    setSearchQuery(e.target.value);
  };

  // const handleCSVExport = () => {
  //   const csv_data = tableData.map((item, index) => {
  //     const d = {
  //       "Group Name": UI.DataHelper.carespan.get_name(item.name) ?? " ",
  //       "Subscription Type": item.planName ?? " ",
  //       "Start Date": item?.relationshipToUser ?? " ",
  //       "End Date": item?.user?.email ?? " ",
  //       "Status": item?.user?.phoneNumber ?? " ",
  //       "Billing": item?.gender ?? " ",
  //     };

  //     return d;
  //   });

  //   UI.DownloadCSV("Subscription Request " + UI.get_current_date_string(), csv_data);
  // };

  const handleClearViaSelectField = (fieldName) => {
    console.log("Handle CLEAR", fieldName);
    if (fieldName === "Date Filter by") {
      setSearchResults([]);
    }
  };

  const updateRequestStatus = (status, subscriptionId, usergroupId) => {
    const payload = {
      userGroupId: usergroupId,
      status: status,
    };

    setIsLoading(true);

    ServiceUsersGroupSubscriptionApi.updateUserGroupSubscriptionPlan(
      subscriptionId,
      payload
    ).then((res) => {
      setIsLoading(false);
      if (
        res.status === 200 &&
        (status === "ACTIVATED" || status === "APPROVED")
      ) {
        _this.show_modal(
          <Success
            title={"APPROVED!"}
            // description={`Successfully ${status} subscription`}
            description={`Group Subscription request approved.`}
            onDismiss={() => {
              getAllUserGroupSubscriptionsRequest();
              _this.hide_modal();
            }}
          />
        );
      } else if (res.status === 200 && status === "DISAPPROVED") {
        _this.show_modal(
          <Success
            title={"DISAPPROVED!"}
            // description={`Successfully ${status} subscription`}
            description={`Group Subscription request disapproved.`}
            onDismiss={() => {
              getAllUserGroupSubscriptionsRequest();
              _this.hide_modal();
            }}
          />
        );
      } else {
        _this.show_modal(
          <Failed
            description={res.message}
            onDismiss={() => {
              _this.hide_loading();
              _this.hide_modal();
            }}
          />
        );
      }
    });
  };

  return (
    <>
      {/* <FilterBox>
        <Title level={5}>Request Subscription List</Title>
        <Toolbar gutter={14}>
          <ToolItem span={8}>
            <StyledFieldLabel>Status</StyledFieldLabel>
            <StyledSelect
              getPopupContainer={(trigger) => trigger.parentNode} // Avoid Select dropdown moves when scrolling
              placeholder="Filter Option"
              style={{
                width: "100%",
              }}
              allowClear
              suffixIcon={<DropdownIcon />}
              onChange={(value) => setFilterByStatus(value)}
              onClear={() => handleClearViaSelectField("Status")}
            >
              <Select.Option title="Action" value="male">
                Pending
              </Select.Option>
              <Select.Option title="Action" value="male">
                Approved
              </Select.Option>
              <Select.Option title="Action" value="female">
                Disapprove
              </Select.Option>
              <Select.Option title="Action" value="female">
                Cancel
              </Select.Option>
            </StyledSelect>
          </ToolItem>
          <ToolItem span={8}>
            <StyledFieldLabel>Billing</StyledFieldLabel>
            <StyledSelect
              getPopupContainer={(trigger) => trigger.parentNode} // Avoid Select dropdown moves when scrolling
              placeholder="Filter Option"
              style={{
                width: "100%",
              }}
              allowClear
              suffixIcon={<DropdownIcon />}
              onChange={(value) => setFilterByStatus(value)}
              onClear={() => handleClearViaSelectField("Status")}
            >
              <Select.Option title="Action" value="male">
                Pending
              </Select.Option>
              <Select.Option title="Action" value="male">
                Approved
              </Select.Option>
              <Select.Option title="Action" value="female">
                Disapprove
              </Select.Option>
              <Select.Option title="Action" value="female">
                Cancel
              </Select.Option>
            </StyledSelect>
          </ToolItem>
        </Toolbar>
      </FilterBox> */}
      <TableBox>
        <Title level={5}>Subscription Requests List</Title>
        <Toolbar>
          <FieldLabel>Only Show</FieldLabel>
          <StyledSelect
            getPopupContainer={(trigger) => trigger.parentNode} // Avoid Select dropdown moves when scrolling
            defaultValue="30"
            style={{
              width: 160,
            }}
            suffixIcon={<DropdownIcon />}
            onChange={handleChangeNumOfEntries}
          >
            <Select.Option value="5">5 Entries</Select.Option>
            <Select.Option value="10">10 Entries</Select.Option>
            <Select.Option value="30">30 Entries</Select.Option>
          </StyledSelect>
          <StyledSearch
            placeholder="Enter Keyword"
            allowClear
            suffix={<SearchIcon />}
            value={searchQuery}
            onChange={(e) => {
              handleChangeSearchQuery(e);
            }}
            onPressEnter={getAllUserGroupSubscriptionsRequest}
            style={{ width: 200 }}
          />
          {/* <StyledButton type="primary" onClick={handleCSVExport}>
            Export to CSV
          </StyledButton> */}
        </Toolbar>
        <DataTable
          tableColumnHeader={tableColumnHeader}
          dataSource={searchResults.length > 0 ? searchResults : tableData}
          defaultPageSize={30}
          pageSizeOptions={["30", "100", totalRecords]}
          tableEntries={tableEntries}
          isBackendPaginated={true}
          totalRecords={totalRecords}
          onPaginate={handlePaginateTable}
          loading={isLoading}
          scroll={{
            x: 600,
          }}
        />
      </TableBox>
    </>
  );
};

export default EcommerceUserGroupSubscriptionRequestListTable;

// CSS Styled Components ----------------------
// const FilterBox = styled(Row)`
//   position: relative;
//   display: flex;
//   flex-direction: column;
//   background: #ffffff 0% 0% no-repeat padding-box;
//   box-shadow: 0px 3px 10px #bfbfbf29;
//   border-radius: 12px;
//   padding: 33px 0 0 0;
//   margin-bottom: 30px;
// `;

const Title = styled(Typography.Title)`
  font-family: Poppins;
  font-weight: 500 !important; //medium
  font-size: 1.4375rem !important; // 15px
  line-height: 1.4375rem !important; // 23px
  letter-spacing: 0 !important;
  color: #004f99 !important;
  padding-left: 35px;
  margin-top: 10px !important;
  margin-bottom: 55px !important;
`;

const TableBox = styled(Row)`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 33px 0 33px 0;
  border-radius: 12px;
  box-shadow: 0px 3px 10px #bfbfbf29;
  background: #ffffff 0% 0% no-repeat padding-box;
  font-family: Poppins;
  width: 60vw;
  min-width: 100%;
  // First Column of Table (Header & Body)
  & .ant-table-row .ant-table-cell:nth-child(1),
  .ant-table-thead .ant-table-cell:nth-child(1) {
    width: 20%;
  }
`;

const Toolbar = styled(Row)`
  display: flex;
  align-items: center;
  padding-left: 35px;
  padding-right: 35px;
  padding-bottom: 33px;
  font-family: Poppins;
  font-weight: 500; //medium
  font-size: 0.9375rem; // 15px
  line-height: 1.4375rem; // 23px
  letter-spacing: 0;
`;

const FieldLabel = styled(Typography.Paragraph)`
  color: #2e2e2e;
  margin-right: 30px;
  margin-bottom: 0 !important;
`;

const StyledSelect = styled(Select)`
  .ant-select-selector {
    border-radius: 12px !important;
    border-width: 2px !important;
    height: 50px !important;
    align-items: center;
    font-size: 0.9375rem; // 15px
    line-height: 1.4375rem; // 23px
    & .ant-select-selection-placeholder {
      color: #2e2e2e;
    }
    // Options
    & .ant-select-selection-item {
      z-index: 1;
    }
  }

  // The Wrapper of Icon
  .ant-select-arrow {
    margin-right: 10px;
    top: 47% !important;
  }
  // The Wrapper of Icon for clear btn, when there's a value
  .ant-select-clear {
    top: 45%;
    right: 45px;
    opacity: 1 !important;
  }
`;

const ActionStyledSelect = styled(Select)`
  .ant-select-selector {
    border-radius: 10px !important;
    border-width: 2px !important;
    height: 40px !important;
    align-items: center;
    font-size: 10px;
    line-height: 1.4375rem;
    & .ant-select-selection-placeholder {
      color: #2e2e2e;
    }
    // Options
    & .ant-select-selection-item {
      z-index: 1;
    }
  }

  // The Wrapper of Icon
  .ant-select-arrow {
    margin-right: 10px;
    top: 47% !important;
  }
  // The Wrapper of Icon for clear btn, when there's a value
  .ant-select-clear {
    top: 45%;
    right: 45px;
    opacity: 1 !important;
  }
`;

// const StyledButton = styled(Button)`
//   height: 50px;
//   border-radius: 12px;
//   border: none;
//   background-color: #0e4d94;
//   font-family: Poppins;
//   font-weight: 500;
//   font-size: 0.9375rem; // 15px
//   line-height: 1.4375rem; // 23px
//   margin-left: 20px;
//   padding-left: 20px;
//   padding-right: 20px;
//   &:hover {
//     background-color: #43c8ff;
//   }
// `;

const StyledSearch = styled(Input)`
  border-radius: 12px !important;
  border-width: 2px !important;
  height: 50px;
  width: 220px !important;
  margin-left: auto;
  .ant-input {
    font-family: Poppins;
    font-weight: 500;
    font-size: 0.9375rem; // 15px
    line-height: 1.4375rem; // 23px
  }
`;
